import sidebar from "./sidebar.json";
import main from "./main.json";
import main2 from "./main2.json";

const container = {
  sidebar,
  main: main,
};

export default container;
